import React, { useContext, useEffect, useRef, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import Btn_loader from '../Btn_loader';
import PageLoading from '../PageLoading';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';

const categoryMeta = {
    personal: { label: "Personal Life", icon: "👤", color: "from-indigo-500 to-blue-500", bg: "bg-indigo-50/50", border: "border-indigo-100/50", text: "text-indigo-600" },
    health: { label: "Health & Vitality", icon: "🏥", color: "from-emerald-500 to-teal-500", bg: "bg-emerald-50/50", border: "border-emerald-100/50", text: "text-emerald-600" },
    career: { label: "Career & Success", icon: "💼", color: "from-amber-500 to-orange-500", bg: "bg-amber-50/50", border: "border-amber-100/50", text: "text-amber-600" },
    profession: { label: "Profession & Wealth", icon: "💼", color: "from-amber-500 to-orange-500", bg: "bg-amber-50/50", border: "border-amber-100/50", text: "text-amber-600" },
    love: { label: "Love & Romance", icon: "💖", color: "from-rose-500 to-pink-500", bg: "bg-rose-50/50", border: "border-rose-100/50", text: "text-rose-600" },
    travel: { label: "Travel & Adventure", icon: "✈", color: "from-sky-500 to-cyan-500", bg: "bg-sky-50/50", border: "border-sky-100/50", text: "text-sky-600" },
    luck: { label: "Luck & Opportunities", icon: "🍀", color: "from-yellow-500 to-amber-500", bg: "bg-yellow-50/50", border: "border-yellow-100/50", text: "text-yellow-600" }
};

const Horoscope = () => {

    const { t } = useTranslation();
    const { BaseUrl, setIsToast, setToastMsg } = useContext(MyContext);
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [selectrasiindex, setSelectRasiIndex] = useState(0);
    const [date, setDate] = useState("");
    const [selecttitle, setSelectTitle] = useState({ title: "Daily Horoscope", key: "daily" });
    const [tablist, setTabList] = useState([{ title: "Yesterday", key: "yesterday" }, { title: "Today", key: "today" }, { title: "Tomorrow", key: "tomorrow" }]);
    const [selecttab, setSelectTab] = useState("yesterday");
    const [alldata, setAllData] = useState("");
    const [apiloading, setApiLoading] = useState(false);

    const HomeRef = useRef(false);

    const typelist = [
        { title: "Daily Horoscope", key: "daily" },
        { title: "Weekly Horoscope", key: "weekly" },
        { title: "Monthly Horoscope", key: "monthly" },
        { title: "Yearly Horoscope", key: "yearly" }
    ];

    const RasiListTitle = [
        "Aries",
        "Taurus",
        "Gemini",
        "Cancer",
        "Leo",
        "Virgo",
        "Libra",
        "Scorpio",
        "Sagittarius",
        "Capricorn",
        "Aquarius",
        "Pisces",
    ];

    const RasiImgList = [
        require("../../image/RashiImg/1_Aries.png"),
        require("../../image/RashiImg/2_Taurus.png"),
        require("../../image/RashiImg/3_Gemini.png"),
        require("../../image/RashiImg/4_Cancer.png"),
        require("../../image/RashiImg/5_Leo.png"),
        require("../../image/RashiImg/6_Virgo.png"),
        require("../../image/RashiImg/7_Libra.png"),
        require("../../image/RashiImg/8_Scorpio.png"),
        require("../../image/RashiImg/9_Sagittarius.png"),
        require("../../image/RashiImg/10_Capricorn.png"),
        require("../../image/RashiImg/11_Aquarius.png"),
        require("../../image/RashiImg/12_Pisces.png")
    ];

    useEffect(() => {
        const Userid = secureLocalStorage.getItem("Userid");
        if (!Userid) {
            setIsToast(true);
            setToastMsg("Please login first !!");
            navigate("/auth/login");
            return;
        }
        handleGetDate(1);
        hndleFetchData(RasiListTitle[selectrasiindex], selecttab, selecttitle.key);
    }, []);

    useEffect(() => {
        if (!HomeRef.current) {
            hndleFetchData(RasiListTitle[selectrasiindex], selecttab, selecttitle.key);
        }
    }, [selectrasiindex, selecttab, selecttitle]);

    const handleGetDate = (index) => {
        const today = new Date();
        const monthsHaf = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const monthsFull = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"];

        const d = String(today.getDate()).padStart(2, "0");
        const m = monthsFull[today.getMonth()];
        const y = today.getFullYear();

        if (index === 1) {
            setDate(`${d} ${t(m)} ${y}`);
        }

        if (index === 2) {
            const start = new Date(today);
            const end = new Date(today);

            const d = today.getDay();
            const diff = d === 0 ? -6 : 1 - d;

            start.setDate(today.getDate() + diff);
            end.setDate(start.getDate() + 6);

            const s = `${String(start.getDate()).padStart(2, "0")} ${monthsHaf[start.getMonth()]}`;
            const e = `${String(end.getDate()).padStart(2, "0")} ${monthsHaf[end.getMonth()]}`;
            const y = end.getFullYear();

            setDate(`${s} - ${e}, ${y}`);
        }

        if (index === 3) {
            setDate(`${m}, ${y}`);
        }

        if (index === 4) {
            setDate(y);
        }
    };

    const handleSelectRasi = (index) => {
        setSelectRasiIndex(index);
        setApiLoading(true);
        HomeRef.current = false;
    }

    const handleHoroscopes = (item, index) => {
        setSelectTitle(item);
        setApiLoading(true);
        HomeRef.current = false;
        if (index === 0) {
            setTabList([{ title: "Yesterday", key: "yesterday" }, { title: "Today", key: "today" }, { title: "Tomorrow", key: "tomorrow" }]);
            setSelectTab("yesterday");
            handleGetDate(1);
        } else if (index === 1) {
            setTabList([{ title: "Prev Week", key: "prevweek" }, { title: "Current Week", key: "currentweek" }, { title: "Next Week", key: "nextweek" }]);
            setSelectTab("prevweek");
            handleGetDate(2);
        } else if (index === 2) {
            setTabList([{ title: "Prev Mont", key: "prevmonth" }, { title: "Current Month", key: "currentmonth" }, { title: "Next Month", key: "nextmonth" }]);
            setSelectTab("prevmonth");
            handleGetDate(3);
        } else {
            setTabList([{ title: "Prev Year", key: "prevyear" }, { title: "Current Year", key: "currentyear" }, { title: "Next Year", key: "nextyear" }]);
            setSelectTab("prevyear");
            handleGetDate(4);
        }
    }

    const handleSelectTab = (key) => {
        HomeRef.current = false;
        setSelectTab(key);
        setApiLoading(true);
    }

    const hndleFetchData = (sign, wb_type, wb_tab) => {
        HomeRef.current = true;
        axios.get(`${BaseUrl}user/horoscope?sign=${sign}&wb_type=${wb_type}&wb_tab=${wb_tab}`)
            .then((res) => {
                if (res.data?.Result === false) {
                    setIsToast(true);
                    setToastMsg(res.data.message || "Something went wrong!");
                    setAllData("");
                    setApiLoading(false);
                    setLoading(false);
                    return;
                }
                setAllData(res.data);
                setApiLoading(false);
                setLoading(false);
            })
            .catch((error) => {
                console.error(error);
                setApiLoading(false);
                setLoading(false);
            });
    }

    return (
        <div className='horoscope_page py-6'>

            {!loading && <div className="width_container">
                {/* Rashi Selector Bar */}
                <div className="relative w-full flex items-center group mb-8 border-b pb-4">
                    <button 
                        onClick={() => {
                            const container = document.getElementById('rasi-container');
                            if (container) container.scrollBy({ left: -200, behavior: 'smooth' });
                        }}
                        className="absolute left-[-15px] z-10 bg-white hover:bg-orange-50 border border-orange-100 shadow-md hover:shadow-lg rounded-full p-2 transition-all duration-300 hover:scale-105 active:scale-95 hidden md:flex items-center justify-center text-orange-500"
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 19L8 12L15 5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>

                    <div id="rasi-container" className="flex gap-4 overflow-x-auto no-scrollbar py-2 px-1 w-full scroll-smooth">
                        {RasiListTitle.map((item, index) => {
                            const isSelected = index === selectrasiindex;
                            return (
                                <button
                                    key={index}
                                    onClick={() => handleSelectRasi(index)}
                                    className={`flex flex-col items-center min-w-[85px] p-3 rounded-2xl transition-all duration-300 ${isSelected ? 'bg-gradient-to-br from-orange-500 to-rose-500 text-white shadow-lg shadow-orange-500/25 scale-105' : 'bg-white text-gray-700 hover:bg-orange-50/50 hover:scale-102 border border-gray-100'}`}
                                >
                                    <img 
                                        src={RasiImgList[index]} 
                                        className={`size-10 object-contain p-1 rounded-full ${isSelected ? 'bg-white/20' : 'bg-orange-50'}`} 
                                        alt={item} 
                                    />
                                    <span className="text-[13px] font-bold mt-2 tracking-tight">{t(item)}</span>
                                </button>
                            );
                        })}
                    </div>

                    <button 
                        onClick={() => {
                            const container = document.getElementById('rasi-container');
                            if (container) container.scrollBy({ left: 200, behavior: 'smooth' });
                        }}
                        className="absolute right-[-15px] z-10 bg-white hover:bg-orange-50 border border-orange-100 shadow-md hover:shadow-lg rounded-full p-2 transition-all duration-300 hover:scale-105 active:scale-95 hidden md:flex items-center justify-center text-orange-500"
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 5L16 12L9 19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                </div>

                {/* Horoscope Banner Header */}
                <div className="relative overflow-hidden rounded-[24px] bg-gradient-to-r from-orange-500/10 via-rose-500/5 to-orange-500/10 border border-orange-100/50 p-6 md:p-8 mb-8 flex flex-col md:flex-row items-center justify-between gap-6">
                    <div className="absolute inset-0 bg-grid-pattern opacity-10" />
                    <div className="flex items-center gap-5 relative z-10">
                        <div className="relative size-20 md:size-24 flex-shrink-0 bg-gradient-to-br from-orange-500 to-rose-500 rounded-full p-1 shadow-lg shadow-orange-500/25">
                            <div className="bg-white rounded-full size-full flex items-center justify-center p-2">
                                <img src={RasiImgList[selectrasiindex]} className="size-full object-contain animate-float" alt={RasiListTitle[selectrasiindex]} />
                            </div>
                        </div>
                        <div>
                            <span className="bg-orange-100 text-orange-700 font-bold px-3 py-1 rounded-full text-[12px] uppercase tracking-wider">{t(selecttitle.title)}</span>
                            <h1 className="text-[26px] md:text-[34px] font-black text-gray-800 tracking-tight mt-1.5 leading-none">
                                {t(RasiListTitle[selectrasiindex])} <span className="bg-gradient-to-r from-orange-500 to-rose-500 bg-clip-text text-transparent">{t("Horoscope")}</span>
                            </h1>
                            <div className="flex items-center gap-1.5 text-gray-500 text-[15px] font-semibold mt-2.5">
                                <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                                    <line x1="16" y1="2" x2="16" y2="6"/>
                                    <line x1="8" y1="2" x2="8" y2="6"/>
                                    <line x1="3" y1="10" x2="21" y2="10"/>
                                </svg>
                                <span>{date}</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Horoscope Main Layout Grid */}
                <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
                    {/* Left sidebar: Type selection */}
                    <div className="col-span-1">
                        <div className="bg-white rounded-[20px] border border-gray-100 p-5 shadow-sm space-y-4">
                            <h2 className="font-bold text-[18px] text-gray-800 tracking-tight flex items-center gap-2">
                                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                                    <path d="M12 20h9M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>
                                </svg>
                                {t("Horoscope Scope")}
                            </h2>
                            <div className="flex flex-col gap-2">
                                {typelist.map((item, index) => {
                                    const isSelected = item.title === selecttitle.title;
                                    return (
                                        <button
                                            key={index}
                                            onClick={() => handleHoroscopes(item, index)}
                                            className={`w-full text-start px-4 py-3 rounded-xl font-bold transition-all duration-300 ${isSelected ? 'bg-orange-50 text-orange-600 border-l-4 border-orange-500 shadow-sm' : 'bg-transparent text-gray-600 hover:bg-gray-50 border-l-4 border-transparent'}`}
                                        >
                                            {t(item.title)}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                    {/* Right area: Tabs and content cards */}
                    <div className="col-span-1 lg:col-span-3">
                        <div className="bg-gray-100 p-1.5 flex items-center gap-2 rounded-2xl w-fit mb-6">
                            {tablist.map((item, index) => {
                                const isSelected = item.key === selecttab;
                                return (
                                    <button
                                        key={index}
                                        onClick={() => handleSelectTab(item.key)}
                                        className={`px-6 py-2.5 rounded-xl font-bold text-[15px] transition-all duration-300 ${isSelected ? 'bg-gradient-to-r from-orange-500 to-rose-500 text-white shadow-md' : 'text-gray-600 hover:text-gray-800 bg-transparent'}`}
                                    >
                                        {t(item.title)}
                                    </button>
                                );
                            })}
                        </div>

                        <div>
                            {apiloading ? (
                                <div className="h-[300px] flex items-center justify-center">
                                    <Btn_loader CustomeStyle={"bg-orange-500"} />
                                </div>
                            ) : (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    {alldata?.prediction && Object.entries(alldata?.prediction).map(([title, value], index) => {
                                        const key = title.toLowerCase();
                                        const meta = categoryMeta[key] || { label: title.charAt(0).toUpperCase() + title.slice(1), icon: "✨", color: "from-orange-500 to-rose-500", bg: "bg-orange-50/50", border: "border-orange-100/50", text: "text-orange-600" };
                                        
                                        return (
                                            <div key={index} className="bg-white rounded-[22px] border border-gray-100 shadow-sm hover:shadow-md hover:translate-y-[-2px] transition-all duration-300 overflow-hidden flex flex-col justify-between">
                                                <div className="p-5 md:p-6 space-y-4">
                                                    <div className="flex items-center gap-3">
                                                        <span className={`text-[24px] p-2 rounded-xl ${meta.bg} ${meta.text}`}>
                                                            {meta.icon}
                                                        </span>
                                                        <div>
                                                            <h3 className="font-bold text-[17px] text-gray-800 tracking-tight">{t(meta.label)}</h3>
                                                            <span className="text-[11px] text-gray-400 font-bold uppercase tracking-wider">{t("Insight")}</span>
                                                        </div>
                                                    </div>
                                                    
                                                    <div className="text-gray-600 text-[15px] leading-relaxed">
                                                        {Array.isArray(value) ? (
                                                            <div className="space-y-1.5">
                                                                {value.map((text, idx) => (
                                                                    <p key={idx}>{text}</p>
                                                                ))}
                                                            </div>
                                                        ) : (
                                                            <p>{value}</p>
                                                        )}
                                                    </div>
                                                </div>
                                                
                                                <div className={`h-1.5 bg-gradient-to-r ${meta.color} w-full opacity-60`} />
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

            </div>}

            <PageLoading loading={loading} />

        </div >
    )
}

export default Horoscope